
/**
 *      Data-driven UI logic for error display
 *
 *      @author Irina Patrikeeva <irina.i.ipatrikeeva@nasa.gov>
 *
 *      Created on 10/26/2017
 *      Modified on 06/11/2018
 */

/**
 * Return an empty function if an Ajax call fails and there's nothing to do after
 * Prints error message and status to the console
 * @param url {string} - Ajax URL parameter
 * @returns {Function}
 */
function dataNotFound( url ) {
    /**
     * Callback that is called when the call to fetch the model a search_url fails
     * @param data {object} - error object
     * @param textStatus {string} - status of the request
     * @param jqXHR {object} - jQuery XMMLHTTPRequest object
     */
    return function ( data, textStatus, errorThrown ) {
        // Empty function - nothing to do DMR data could not be fetched

        // Set global variable
        makingAjaxRequest = false;

        console.log( "URL: ");
        console.log( url );
        console.log( "Data:" );
        console.log( data );
        console.log( "Status: " + textStatus );
        console.log( "Error thrown: " + errorThrown );

        // Hide all loading icons
        hideSearchLoadingIcon('search-loading-icon');
        hideSearchLoadingIcon('facets-loading-icon');
    };
}

/**
 * Display error message, except for aborted requests per USRA-439
 * @param message {string} - message to log
 * @param jqXHR {object} - jQuery XMLHttpRequest object
 * @param textStatus {string} - status of the request
 * @param errorThrown {string} - textual portion of the HTTP status
 */
function displayErrorView( message, jqXHR, textStatus, errorThrown ){
    var errorSearchModel,
        errorView,
        LayoutView,
        pageId = "page-layout",
        errorRegionId = "error-region",
        template = "#viewer-layout",
        layoutView;

    if ( textStatus && textStatus.toLowerCase() !== "abort" ) {
        if ( console && console.log ) {
            console.log( 'Error making Ajax request with status ' + textStatus + '.');
            console.log( 'Error thrown: ' + errorThrown );
            console.log( message );
        }

        // Display error message to the user

        errorSearchModel = new SearchErrorModel({ message: errorThrown, statusText: textStatus, status: jqXHR.status });
        errorView = new ErrorView( { model: errorSearchModel } );
        LayoutView = Backbone.Marionette.LayoutView.extend({
            template: template
        });

        layoutView = new LayoutView({ el: '#' + pageId });
        layoutView.addRegion( errorRegionId, '#' + errorRegionId );
        addRegionElement( errorRegionId, pageId );

        App.globalState.layout = layoutView;
        if ( $( App.globalState.layout.getRegion( errorRegionId ).el ).length > 0 ) {
            App.globalState.layout.getRegion( errorRegionId ).show( errorView );
        }
    }
}
